import { featureAccessStore } from 'stores/featureAccessStore'

export const setFeatureAccess = (featureAccessData: any[]) => {
  // Temporary variables for combined feature flags
  let COMMUNICATIONS_PUSHNOTIFICATIONS = false
  let COMMUNICATIONS_BANNERMESSAGES = false
  let REWARDS_JJ = false
  let REWARDS_LOCATION = false
  let SWEEPSTAKES_JJ = false
  let SWEEPSTAKES_LOCATION = false

  // Loop through each feature access and set the store values
  featureAccessData?.forEach((feature) => {
    switch (feature.featureType?.toUpperCase()) {
      case 'UNKNOWN':
        featureAccessStore.setState({ unknown: feature.allowed ?? false })
        break
      case 'PATRON':
        featureAccessStore.setState({ patron: feature.allowed ?? false })
        break
      case 'CHECKIN':
        featureAccessStore.setState({ checkin: feature.allowed ?? false })
        break
      case 'TIERS':
        featureAccessStore.setState({ tiers: feature.allowed ?? false })
        break
      case 'SPECIALSANDEVENTS':
        featureAccessStore.setState({
          specialsAndEvents: feature.allowed ?? false,
        })
        break
      case 'REWARDS_JJ':
        REWARDS_JJ = feature.allowed ?? false
        featureAccessStore.setState({ rewardsJJ: feature.allowed ?? false })
        break
      case 'REWARDS_LOCATION':
        REWARDS_LOCATION = feature.allowed ?? false
        featureAccessStore.setState({
          rewardsLocation: feature.allowed ?? false,
        })
        break
      case 'SWEEPSTAKES_JJ':
        SWEEPSTAKES_JJ = feature.allowed ?? false
        featureAccessStore.setState({ sweepstakesJJ: feature.allowed ?? false })
        break
      case 'SWEEPSTAKES_LOCATION':
        SWEEPSTAKES_LOCATION = feature.allowed ?? false
        featureAccessStore.setState({
          sweepstakesLocation: feature.allowed ?? false,
        })
        break
      case 'COMMUNICATIONS_PUSHNOTIFICATIONS':
        COMMUNICATIONS_PUSHNOTIFICATIONS = feature.allowed ?? false
        featureAccessStore.setState({
          communicationsPushNotifications: COMMUNICATIONS_PUSHNOTIFICATIONS,
        })
        break
      case 'COMMUNICATIONS_BANNERMESSAGES':
        COMMUNICATIONS_BANNERMESSAGES = feature.allowed ?? false
        featureAccessStore.setState({
          communicationsBannerMessages: COMMUNICATIONS_BANNERMESSAGES,
        })
        break
      default:
        break
    }
  })

  // Set any other feateure variables based on combinations of flags
  // For use when needing to check multiple feature flags so the code can check one variable instead of many
  featureAccessStore.setState({
    noCommunications:
      !COMMUNICATIONS_PUSHNOTIFICATIONS && !COMMUNICATIONS_BANNERMESSAGES,
    noRewards: !REWARDS_JJ && !REWARDS_LOCATION,
    noSweepstakes: !SWEEPSTAKES_JJ && !SWEEPSTAKES_LOCATION,
  })
}
